export default {
    physician: 'Provider',
    invite_network: 'Invite to network',
    invite_practice: 'Invite to practice',
    practice_name: 'Practice name',
    invite_by: 'Invite By {inviteType}',
}
